import React from "react";
import Zoom from "react-reveal/Zoom";
import { useTranslation } from 'react-i18next';

const WinMessage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="landing">
        <Zoom>
          <h1>{t('You Win')}!!!</h1>
        </Zoom>
      </div>
    </div>
  );
};

export default WinMessage;
